import { PenLine } from 'lucide-react';
import { CarryStatCard } from './CarryStatCard';

interface OpenToSignCardProps {
  count: number;
  description: string;
}

export function OpenToSignCard({ count, description }: OpenToSignCardProps) {
  return (
    <CarryStatCard
      icon={PenLine}
      tone="amber"
      title="Open documents to sign"
      value={count}
      description={description}
    />
  );
}
